import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    config: {},
    logged_in: false,
    isLoading: false,
    locations: [],
    modal: false,
    modalsOpenId: null,
    modalsOpenPhoto: null
  },
  mutations: {
    openModal (state, obj) {
      state.modal = true
      state.modalsOpenId = obj.id
      state.modalsOpenPhoto = obj.photo_url
    },
    closeModal (state) {
      state.modal = false
    },
    login (state, data) {
      state.logged_in = true
      state.config = data
    },
    logout (state) {
      state.logged_in = false
      state.config = {}
    },
    updateUser (state, data) {
      state.config.user = data
    },
    updatePayload (state, data) {
      state.payload.image = data
    },
    updateLocations (state, data) {
      state.locations = data
    }
  },
  actions: {

  }
})
